import {NzUploadXHRArgs} from 'ng-zorro-antd/upload';
import {Subscription} from 'rxjs';


export function getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
}

// export function getSafeImageUrl(url: string | undefined): string {
//   if (!url?.includes('/') || !url?.includes('.')) {
//     return 'assets/images/partner_avatar_placeholder.png'
//   }
//   return url || 'assets/images/partner_avatar_placeholder.png';
// }
export const getSafeImageUrl = (source: unknown): string => {
  if (source instanceof File) return URL.createObjectURL(source);

  if (typeof source === 'string' && source) {
    return source; // Confiamos que es una URL válida
  }

  return 'assets/images/partner_avatar_placeholder.png';
};

// Función para convertir una URL a base64
export async function getBase64ImageFromUrl(url: string): Promise<string> {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

// Metodo para prevenir el error en el navegador de una peticion erronea del nz-upload
export function customUpload(item: NzUploadXHRArgs): Subscription {
  // Simula un retardo (opcional)
  setTimeout(() => {
    // Llama al callback de éxito para que nz-upload marque el archivo como subido
    item.onSuccess!({}, item.file, null);
  }, 0);
  // Retorna una suscripción vacía, ya que no se está haciendo una petición real
  return new Subscription();
}
export function base64ToFile(base64String: string, filename: string): File {
  // Remover el prefijo data:image/...;base64, si existe
  const base64Data = base64String.includes(',')
    ? base64String.split(',')[1]
    : base64String;

  // Convertir base64 a blob
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Determinar el tipo MIME desde el nombre del archivo o usar genérico
  const extension = filename.split('.').pop()?.toLowerCase();
  let mimeType = 'application/octet-stream';
  if (extension === 'pdf') mimeType = 'application/pdf';
  else if (['jpg', 'jpeg'].includes(extension || '')) mimeType = 'image/jpeg';
  else if (extension === 'png') mimeType = 'image/png';
  else if (extension === 'doc') mimeType = 'application/msword';
  else if (extension === 'docx') mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

  const blob = new Blob([byteArray], { type: mimeType });
  return new File([blob], filename, { type: mimeType });
}
